import { render } from "./PaymentCanceledPage.vue?vue&type=template&id=0f89af9e"
import script from "./PaymentCanceledPage.vue?vue&type=script&lang=js"
export * from "./PaymentCanceledPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__